const styles = {
  blue: {
    color: "rgb(33,77,142)",
    paddingRight: "0",
  },
  red: {
    color: "rgb(220,38,72)",
    paddingLeft: "0",
  },
  spinner: {
    marginTop: "12vh",
    marginBottom: "9vh",
  },
  calendar: {
    backgroundColor: "#F5F5F5",
    padding: "0",
    paddingTop: "0",
    paddingBottom: "15px",
    marginLeft: "15px",
    marginRight: "15px",
    marginTop: "0",
  },
  headerText: {
    position: "relative",
    paddingLeft: "33px",
    fontFamily: "IBM Plex Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "23px",
    lineHeight: "28px",
    color: "#000000",
  },
  widthHeaderText: {
    width: "calc(100vw - 125px)",
  },
  conatainer: {
    paddingBottom: "23px",
  },
  containerInfo: {
    marginBottom: "39px",
  },
};

export default styles;
